export default __webpack_public_path__ + "static/media/design-notes.d0b0e268.svg";